import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'
export const BEGIN_OAUTH = 'BEGIN_OAUTH'

export const authorizeWithOauth = (provider, type) => (dispatch) => {
  const { pathname } = window.location
  dispatch({
    type: BEGIN_OAUTH,
    payload: { pathname, provider }
  })
  let typeAddition = ''
  if (type) typeAddition = `&type=${type}`
  window.location.href = `/api/oauth/authorize/${provider}?redirect=${encodeURIComponent(pathname)}${typeAddition}`
}

export const CLEAR_OAUTH_SETTINGS = 'CLEAR_OAUTH_SETTINGS'

export const clearOauthSettings = createAction(CLEAR_OAUTH_SETTINGS)

export const REQUEST_OAUTH_USER_DATA = 'REQUEST_OAUTH_USER_DATA'
export const REQUEST_OAUTH_USER_DATA_ERROR = 'REQUEST_OAUTH_USER_DATA_ERROR'
export const RECEIVE_OAUTH_USER_DATA = 'RECEIVE_OAUTH_USER_DATA'
export const CLEAR_OAUTH_USER_DATA = 'CLEAR_OAUTH_USER_DATA'
export const clearOauthUserData = createAction(CLEAR_OAUTH_USER_DATA)

export const fetchOauthUserData = (provider, workspaceId, sourceSlug, integrationSlug) => (dispatch) => {
  let callURL = `/api/oauth-user-data/${provider}/${workspaceId}/${sourceSlug}`
  const payload = { provider, workspaceId, sourceSlug }
  if (integrationSlug) {
    callURL += `/${integrationSlug}`
    payload.integrationSlug = integrationSlug
  }
  dispatch(createAction(REQUEST_OAUTH_USER_DATA)())
  return fetch(callURL)
    .then(res => {
      if (!res.ok) {
        const error = new Error(`Unable to fetch oauth user data for ${provider}`)
        error.status = res.status
        throw error
      }
      const response = res.json()
      dispatch(createAction(RECEIVE_OAUTH_USER_DATA)({
        ...payload,
        response
      }))
      return response
    }).catch((err) => dispatch(createAction(REQUEST_OAUTH_USER_DATA_ERROR)(err)))
}

// Oauth LocalStorage interaction

export const REMOVE_OAUTH_LOCAL_STORAGE_VALUE = 'REMOVE_OAUTH_LOCAL_STORAGE_VALUE'
export const REMOVE_OAUTH_LOCAL_STORAGE_VALUE_ERROR = 'REMOVE_OAUTH_LOCAL_STORAGE_VALUE_ERROR'
export const removeOauthLocalStorageValue = createAction(REMOVE_OAUTH_LOCAL_STORAGE_VALUE)
export const removeOauthLocalStorageValueError = createAction(REMOVE_OAUTH_LOCAL_STORAGE_VALUE_ERROR)

export const removeLocalStorageValue = (key) => (dispatch) => {
  return new Promise((resolve, reject) => {
    try {
      window.localStorage.removeItem(key)
      dispatch(removeOauthLocalStorageValue({ key }))
      resolve()
    } catch (error) {
      dispatch(removeOauthLocalStorageValueError({ key, error }))
      reject(error)
    }
  })
}
export const setOauthLocalStorageValue = (key, value) => {
  return new Promise((resolve, reject) => {
    try {
      window.localStorage.setItem(key, value)
      resolve()
    } catch (e) {
      reject(e)
    }
  })
}
export const initAuthFlowFlags = (provider) => setOauthLocalStorageValue('isInAuthFlow', provider)
export const clearOauthLocalStorage = () => (dispatch) => dispatch(removeLocalStorageValue('isInAuthFlow'))



// WEBPACK FOOTER //
// ./actions/oauth.js